
import React from 'react';
import Layout from '../../components/Layout/HeadLessLayout';
import Login from './Login';

function action({ intl, store }) {
  const title = 'Log In';

  // From Redux Store
  let isAdminAuthenticated = store.getState().runtime.isAdminAuthenticated;

  if (isAdminAuthenticated) {
    // Sejalan dengan tujuan setelah login di actions/.../login.js: yang sudah
    // masuk lalu membuka halaman login juga mendarat di dashboard baru.
    return { redirect: '/admin' };
  }

  return {
    title,
    component: (
      <Layout>
        <Login title={title} />
      </Layout>
    ),
  };
}

export default action;
